import { Injectable } from '@angular/core';
import {GritApiService} from "./grit.api.service";
import {ReceiverModel} from "../../models/grit/grit.receiver-model";
import {ModalConfirmationService} from "../modal-confirmation.service";
import {UiBlockService} from "../ui-block.service";
import {ModalControlService} from "../modal-control.service";
import { Subscription, interval, takeWhile } from 'rxjs';
import { EndpointsService } from '../endpoints.service';

@Injectable({
  providedIn: 'root'
})
export class GritReceiverService {

  tabState : boolean = false;
  receivers : ReceiverModel[];

  constructor(
    private gritApiService : GritApiService,
    protected modalConfirmation: ModalConfirmationService,
    private uiBlock: UiBlockService,
    protected modalService: ModalControlService,
    private endpointsService: EndpointsService
  ) {
    const checkAuthSubscription: Subscription = interval(100) // ms
      .pipe(takeWhile(() => !this.endpointsService.httpOptions, true))
      .subscribe(() => {
        if (this.endpointsService.httpOptions) {
          checkAuthSubscription.unsubscribe();
          this.getReceivers();
        }
      });
  }

  get receiversSorted() : ReceiverModel[]{
    return this.receivers
      .sort((a, b) => a.name.localeCompare(b.name))
      .sort((a,b) => Number(b.calculationUse) - Number(a.calculationUse))
  }

  public toggleTab(open: boolean){
    this.tabState = open;
  }

  public getReceivers() {
    this.gritApiService.receiverGetAll()
      .then(
        (response) => this.receivers = response ?? [],
        (error) => console.log("Error getting receivers type")
      );
  }

  public getTypeReceiver(type: string) : ReceiverModel{
    let receivers = this.receivers.filter(receiver => receiver.calculationUse && receiver.deviceType == type);

    if (receivers.length == 0) return null;
    receivers.sort((a,b) => a.threshold.dBW - b.threshold.dBW)
    return receivers.at(0);
  }

  importReceivers(receivers : ReceiverModel[]){
    this.modalConfirmation.showMesssageConfirmationModal(
      "Import Receivers",
      "Do you want to import the Receivers?",
      "OK", "Cancel",
      () => {
        this.uiBlock.startBlock("Importing Receivers")
        this.gritApiService.receiverCreate(receivers).then(
          (receivers) => {
            this.receivers.push(...receivers);
            this.modalService.showMesssageModal('Import Success', "Receivers were successfully imported.");
          },
          (error) => {
            console.error(error)
            this.modalService.showMesssageModal('Import Failed', "Failed importing Receivers. Check if structure is equal to export.");
          }
        ).finally(()=>this.uiBlock.stopBlock())
      }
    );
  }
}
